import styled from 'styled-components';

export const Content = styled.section`
`;
export const ContentTitle = styled.div`
  margin: 9.0rem 0 3.0rem  0;
  display: flex;
  align-items:baseline;
  h2{
    margin-right: 1.0rem;
    font-size: 2.7rem;
  }
`;

export const List = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: 20px;
`;
